import {
  formatDate,
  formatMoney,
  formatNumber,
  formatCount,
  formatPhone,
  formatTime,
  formatName,
  formatTimeStr,
  formatDistance,
  formatMoneyInteger,
  formatMoneyDecimal
} from 'utils/common'

export default {
  formatDate,
  formatMoney,
  formatNumber,
  formatMoneyInteger,
  formatMoneyDecimal,
  formatCount,
  formatPhone,
  formatTime,
  formatName,
  formatTimeStr,
  formatDistance
}
